export default __webpack_public_path__ + "static/media/circleNoneTp.29b7c429.svg";